import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loading from '../../core/Loading';
import Ranking from '../../views/Audiences/ranking';

import { setDataRanking } from '../../../actions';

class RankingHomeWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      onErrorLoadData: false,
      dataRanking: null
    };
  }

  componentDidMount() {
    const { setDataRankingHandler } = this.props;

    setDataRankingHandler()
      .then(data => {
        this.setState({
          dataRanking: data
        });
      })
      .catch(() => {
        this.setState({
          onErrorLoadData: true
        });
      })
      .finally(() => {
        this.setState({
          loading: false
        });
      });
  }

  getRender = () => {
    const { loading, dataRanking, onErrorLoadData } = this.state;
    if (loading) {
      return <Loading size="m" />;
    }
    if (onErrorLoadData) {
      return (
        <p>Lo sentimos, pero no tenemos datos para la fecha seleccionada</p>
      );
    }
    return <Ranking data={dataRanking} />;
  };

  render() {
    return this.getRender();
  }
}

const mapStateToProps = state => ({
  dataRanking: state.audiences.dataRanking
});

const mapDispatchToProps = dispatch => ({
  setDataRankingHandler: () => setDataRanking(dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RankingHomeWrapper);
